import * as React from "react";
import { style } from "typestyle";

type Props = {
  title: string;
  children: React.ReactNode;
};
export default class DashboardButtonGroup extends React.Component<Props> {
  render(): JSX.Element | null {
    const { title, children } = this.props;
    if (React.Children.toArray(children).every(button => !button)) {
      return null;
    }
    return (
      <div className={style({})}>
        {title && (
          <div
            className={style({
              marginBottom: "16px",
              padding: "0 22px",
              color: "rgba(0,0,0,0.87)",
              fontFamily: "Roboto, Arial, sans-serif",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "24px",
            })}
          >
            {title}
          </div>
        )}
        <div
          className={style({
            $nest: {
              "&>*": {
                marginTop: "16px",
              },
              "&>*:first-child": {
                marginTop: "0",
              },
            },
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}
